import {AxiosError} from 'axios';
import {LocationResponse} from '../services/azure-location-service';
import { CoordsResponse , MqttGeoLocationPoint} from '../types';

const getErrorMessage = (error: any): any => {
  let err:any = '';
  if(error?.isAxiosError){
    err = JSON.stringify((error as AxiosError).response?.data);
  }else{
    err = JSON.stringify(error);
  }
  return err;
};

export const extractErrorMessage =(error:any):{errorMessage:string, statusCode:string}=>{
  let err = JSON.parse(getErrorMessage(error));
  let errorMessage = '';
  let statusCode = err?.status ?? '';
  if (err?.errorMessage) {
      errorMessage = err.errorMessage;
  }
  else if(err?.errors) {
      errorMessage = (Object.values(err.errors) as string[][]).map((x: string[]) => x.join(';')).join(';');
  }
  else if(err?.title){
      errorMessage = err.title
  }
  else if(error?.message){
    const errResponse= JSON.parse(JSON.stringify(error.response));
    statusCode = errResponse.status;
    errorMessage = error.message;
  }
  return {
    errorMessage,
    statusCode
  };
}


 export const inferRelevantCoordinates = (data:LocationResponse):CoordsResponse=>{
   const isLiberkee = !!data.liberkeeLat && !!data.liberkiLon;

   if(isLiberkee){
     return {x:data.liberkeeLat! , y:data.liberkiLon!};
   }

   return { x:0 , y:0 };

 }

 export const binarySearch = (arr:MqttGeoLocationPoint[], day:number):number=>{
  let start = 0;
  let end = arr.length - 1;
  let middle = Math.floor((start + end) / 2);
  let searchableDay = new Date(arr[middle].time).getDate();

  while(searchableDay !== day && start <= end){
    if(day < searchableDay){
      start = middle + 1;
    } else{
      end = middle - 1;
    }
    middle = Math.floor((start + end) / 2);
    searchableDay = new Date(arr[middle].time).getDate();
  }

  return searchableDay === day ? middle : -1;
}

export const filterWithinTheInterval = (list:MqttGeoLocationPoint[], from:number , to:number | null, dividingMonthsIndex?:number):[number, number][]=>{
    if (from && !to){
      return list.filter( (element:MqttGeoLocationPoint) => new Date(element.time).getDate() === from)
                 .map( item => [item.longitude, item.latitude]);
    }
    if((from && to!) && from < to!){
       const currentMonthDays = list.slice(0, dividingMonthsIndex);
       const prevoiusMonthFromDay = new Date(list[dividingMonthsIndex!].time).getDate();
       const filteredPrevoiusMonthDays = list.slice(dividingMonthsIndex)
                                        .filter( element => new Date(element.time).getDate() <= prevoiusMonthFromDay && new Date(element.time).getDate() >= to!);
       return [...currentMonthDays, ...filteredPrevoiusMonthDays].map(item => [item.longitude, item.latitude]);
    }
    
    return list.filter( (element:MqttGeoLocationPoint) => new Date(element.time).getDate() <= from && new Date(element.time).getDate() >= to!)
               .map(item => [item.longitude, item.latitude]);
}

export const buildComparisonConfig = (currentMonthDaysList:number[],maxPrevMonthDay:number):any=>{
  const sorted = currentMonthDaysList.sort((a:number, b:number) => a < b ? -1 : 1);

  return {
    comparisonConfig:sorted.reduce( (result:any,num:number, index:number) => {
      result[`${maxPrevMonthDay + index + 1}`] = num;
      return result;
   },{}),
    max:maxPrevMonthDay + sorted[sorted.length - 1],
  }
}

export const createDaysList = (max:number, min:number)=>{
  const daysList = [];
    for (let i = max; i >= min; i--){
        daysList.push(i);
    }
  return daysList;
}

export const getSubstitutedDay = (day:number, comparisonConfig:any):number | null=>{
  if(!comparisonConfig){
     return null;
  }

  for (let key in comparisonConfig){
    if(comparisonConfig[key] === day) return +key;
  }
  return null;
}